import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table, Tag, Switch, Dropdown, Button } from "antd";
import { IconPlus, IconArrowRight } from "@tabler/icons-react";
import CustomBtn from "../../components/btn/CustomBtn";
import CustomInput from "../../components/input/CustomInput";
import CustomSelect from "../../components/select/CustomSelect";
import PageHeader from "../../components/header/PageHeader";
import api from "../../api";
import { useToast } from "../../components/toast";
import UploadImage from "../../components/upload/UploadImage";
import ConfirmModal from "../../components/modal/ConfirmModal";

export default function ClassList() {
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);
  const [toggleId, setToggleId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const toast = useToast();

  // form
  const [program, setProgram] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [bookWithinHours, setBookWithinHours] = useState(null);

  const programOptions = [
    { value: "YOGA", label: "Yoga" },
    { value: "MEGAFORMER", label: "Megaformer" },
  ];

  const fetchData = async () => {
    setListLoading(true);
    const res = await api.get_classes();
    if (res?.status === 200) {
      setList(res.data.data || []);
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
    setListLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const resetForm = () => {
    setEditingId(null);
    setProgram(null);
    setTitle("");
    setDescription("");
    setCoverImage("");
    setBookWithinHours(null);
  };

  const openCreate = () => {
    resetForm();
    setShowModal(true);
  };

  const openEdit = (row) => {
    setEditingId(row.id);
    setProgram(row.program);
    setTitle(row.title);
    setDescription(row.description || "");
    setCoverImage(row.cover_image || "");
    setBookWithinHours(row.book_within_hours_before ?? null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    resetForm();
  };

  const handleSave = async () => {
    if (!program || !title.trim()) {
      toast("Program болон Title заавал.", "error");
      return;
    }

    const payload = {
      title: title.trim(),
      description: description?.trim() || null,
      cover_image: coverImage?.trim() || null,
      book_within_hours_before:
        bookWithinHours === null || bookWithinHours === ""
          ? null
          : Number(bookWithinHours),
    };

    if (!editingId) {
      payload.program = program;
    }

    setLoading(true);
    let res;
    if (editingId) {
      res = await api.update_class(editingId, payload);
    } else {
      res = await api.create_class(payload);
    }
    if (res.status === 200 || res.status === 201) {
      toast("Амжилттай", "success");
      handleClose();
      fetchData();
    } else {
      toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const res = await api.delete_class(id);
    if (res.status === 204) {
      toast("Амжилттай", "success");
      setEditingId(null);
      fetchData();
    } else {
      toast(res?.data?.message || "Устгахад алдаа гарлаа", "error");
    }
  };

  const handleToggle = async (id) => {
    const res = await api.toggle_class(id);
    if (res.status === 200) {
      fetchData();
      toast("Амжилттай", "success");
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
    setToggleId(null);
  };

  const columns = useMemo(
    () => [
      {
        title: "Төрөл",
        dataIndex: "program",
        key: "program",
        width: 140,
        render: (val) => {
          return (
            <Tag color={val === "YOGA" ? "blue" : "cyan"}>{val || ""}</Tag>
          );
        },
      },
      { title: "Гарчиг", dataIndex: "title", key: "title" },
      { title: "Дэлгэрэнгүй", dataIndex: "description", key: "description" },
      {
        title: "Зураг",
        dataIndex: "cover_image",
        key: "cover_image",
        width: 140,
        render: (url) =>
          url ? (
            <img
              alt="cover"
              src={url}
              style={{
                width: 56,
                height: 36,
                objectFit: "cover",
                borderRadius: 4,
              }}
            />
          ) : (
            <span style={{ color: "#999" }}>–</span>
          ),
      },
      {
        title: "Захиалах цаг (эхлэхээс өмнө)",
        dataIndex: "book_within_hours_before",
        key: "book_within_hours_before",
        width: 250,
        render: (v) => (v == null ? "-" : v + " цаг"),
      },
      {
        title: "Төлөв",
        dataIndex: "active",
        key: "active",
        render: (_, row) => (
          <Switch
            checked={!!row.active}
            onChange={() => {
              setToggleId(row.id);
              setToggleModal(true);
            }}
          />
        ),
      },
      {
        title: "Үйлдэл",
        key: "actions",
        width: 150,
        render: (_, record) => {
          const items = (record) => [
            {
              key: "edit",
              label: (
                <span style={{ color: "black", fontSize: "13px" }}>Засах</span>
              ),
            },
            {
              key: "delete",
              label: (
                <span style={{ color: "red", fontSize: "13px" }}>Устгах</span>
              ),
            },
          ];

          return (
            <Dropdown
              menu={{
                items: items(record),
                onClick: ({ key }) => {
                  if (key === "delete") {
                    // console.log("Устгах:", record);
                    setEditingId(record.id);
                    setVisible(true);
                  } else if (key === "edit") {
                    openEdit(record);
                    // console.log("detail", record);
                    // setSelectedRecord(record);
                    // setShowDrawer(true);
                  }
                },
              }}
              trigger={["click"]}
            >
              <Button variant="filled" color="default" style={{ fontSize: 12 }}>
                Үйлдэл
                <IconArrowRight size={12} />
              </Button>
            </Dropdown>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <PageHeader
        title={"Өрөө"}
        right={
          <CustomBtn
            title="Өрөө үүсгэх"
            icon={<IconPlus size={18} />}
            onClick={openCreate}
          />
        }
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={listLoading}
        rowHoverable={false}
        pagination={{ pageSize: 10, showSizeChanger: false }}
      />

      <Modal
        open={showModal}
        width={520}
        title={editingId ? "Өрөө засах" : "Өрөө үүсгэх"}
        onCancel={handleClose}
        footer={
          <div className="d-flex gap-2 justify-content-end">
            <CustomBtn type="secondary" title="Болих" onClick={handleClose} />
            <CustomBtn
              title={"Хадгалах"}
              onClick={handleSave}
              disabled={!loading && program && title ? false : true}
              loading={loading}
            />
          </div>
        }
      >
        <div className="d-flex flex-column gap-2">
          <CustomSelect
            required
            title="Program"
            value={program}
            onChange={(v) => setProgram(v)}
            options={programOptions}
            showSearch
          />
          <CustomInput
            required
            title="Гарчиг"
            placeholder="-"
            value={title}
            onChange={(e) => setTitle(e?.target?.value)}
          />
          <CustomInput
            title="Дэлгэрэнгүй"
            placeholder="-"
            value={description}
            onChange={(e) => setDescription(e?.target?.value)}
          />
          <UploadImage
            title={"Cover зураг"}
            value={coverImage}
            onUpload={(url) => {
              // console.log("SET COVER:", url);
              setCoverImage(url);
            }}
          />
          {program === "MEGAFORMER" && (
            <CustomInput
              title="Эхлэхээс хэдэн цагийн өмнө захиалга нээх вэ"
              placeholder="Эхлэхээс өмнөх нээлттэй цаг"
              value={bookWithinHours}
              onChange={(e) => setBookWithinHours(e?.target?.value)}
            />
          )}
        </div>
      </Modal>

      <ConfirmModal
        showModal={visible}
        setShowModal={setVisible}
        variant="error"
        title="Итгэлтэй байна уу?"
        description={
          <>
            '<span style={{ fontWeight: 600, color: "#000" }}>Өрөө устгах</span>
            ' үйлдэл нь буцаах боломжгүйг анхаарна уу!
          </>
        }
        cancelHandler={() => setEditingId("")}
        submitHandler={() => handleDelete(editingId)}
      />

      <ConfirmModal
        showModal={toggleModal}
        setShowModal={setToggleModal}
        variant="warning"
        title="Итгэлтэй байна уу?"
        description={
          <>
            '
            <span style={{ fontWeight: 600, color: "#000" }}>
              Төлөв өөрчлөх
            </span>
            ' үйлдлийг хийснээр тухайн өрөө нь хэрэглэгчдэд{" "}
            <span style={{ fontWeight: 600, color: "#000" }}>
              харагдахгүй / харагдана
            </span>{" "}
            болохыг анхаарна уу!
          </>
        }
        cancelHandler={() => setToggleId(null)} // 🆕
        submitHandler={() => toggleId && handleToggle(toggleId)} // 🆕
      />
    </>
  );
}
